export const NOT_ELIGIBLE_HEADING = 'Account Not Eligible';
export const NOT_ELIGIBLE_TEXT =
  'The services associated with the account number provided are not eligible for self-installation. If you believe you reached the page in error, please try again with a valid account.';
export const BUTTON_TEXT = 'Try Again';
